import {FC, useState} from 'react'
import Card from '_core/components/Card'
import {KTSVG} from '_metronic/helpers'
import {draftOrderTypes} from 'app/features/orders/models'
import Address from './Address'
import CustomerAddressDialog from './CustomerAddressDialog'
import {deliveryTypes} from 'app/constant'
import Payment from './Payment'
import CustomerPaymentDialog from './CustomerPaymentDialog'
import { CustomerEmail, CustomerName, CustomerPhone } from 'app/components/customer/CustomerInfo'

type CustomerProps = {
  id?: any
  customer: any
  shippingAddress: any
  paymentMethod?: any
  billingAddress?: any
  onDelete?: any
  orderStatus?: string
  orderDeliveryMethod?: any
  isShowCompany?: boolean
}

const Customer: FC<CustomerProps> = ({
  id,
  customer,
  shippingAddress,
  billingAddress,
  onDelete,
  orderStatus,
  paymentMethod,
  orderDeliveryMethod,
  isShowCompany,
}) => {
  const [address, setAddress] = useState<any>({
    dialog: false,
    title: null,
  })

  const [showDialog, setShowDialog] = useState(false)
  const handleCreateAddress = (e: any) => {
    const {value: title} = e.target
    setAddress({
      dialog: true,
      title,
    })
  }

  const handleCloseAddress = () => {
    setAddress({
      dialog: false,
    })
  }

  const handleShowPayment = () => {
    setShowDialog(true)
  }

  const handleClosePayment = () => {
    setShowDialog(false)
  }

  if (!customer) {
    return null
  }
  return (
    <Card
      title='Customer'
      className='pb-10'
      toolbar={
        <>
          {onDelete && orderStatus === draftOrderTypes.open && (
            <button
              id='btnCustomerDelete'
              type='button'
              className='btn btn-icon btn-sm btn-light-danger'
              onClick={onDelete}
              title='Delete'
            >
              <span className='svg-icon svg-icon-1'>
                <KTSVG
                  path='/media/icons/duotune/general/gen034.svg'
                  className='svg-icon-muted svg-icon-2hx'
                />
              </span>
            </button>
          )}
        </>
      }
    >
      <div className='d-flex flex-column'>
        <span className='text-dark fw-bolder text-hover-primary fs-6'>
        <CustomerName firstName={customer.firstName} lastName={customer.lastName} />
        </span>
        <div className='fw-bolder mt-5'>Email</div>
        <div className='text-gray-600'>
          <span className='text-gray-600 text-hover-primary'> <CustomerEmail email={customer.email}/></span>
        </div>
        <div className='fw-bolder mt-5'>Phone</div>
        <div className='text-gray-600'>
          <span className='text-gray-600 text-hover-primary'><CustomerPhone phone={customer.phone}/></span>
        </div>
        {isShowCompany && (
          <>
            <div className='fw-bolder mt-5'>Shipping Preference Company</div>
            <div className='text-gray-600'>
              <span className='text-gray-600'>
                <div>
                  {customer.shippingPreferenceCompany ? customer.shippingPreferenceCompany : '-'}
                </div>
              </span>
            </div>
          </>
        )}
        <div className='separator my-5 mx-n10'></div>

        <div className='flex-row flex-stack flex-wrap'>
          {shippingAddress && (
            <>
              <Address
                address={shippingAddress}
                title='Shipping Address'
                customerId={customer?.id}
                orderStatus={orderStatus}
              />
              <div className='separator my-5'></div>
            </>
          )}
          {orderDeliveryMethod !== deliveryTypes.pickup && !shippingAddress && !id && (
            <AddAddress
              title='Shipping Address'
              value='Shipping Address'
              onChange={handleCreateAddress}
              orderStatus={orderStatus}
            />
          )}
          {paymentMethod && !paymentMethod.id && (
            <AddAddress
              title='Payment Method'
              value='Payment Method'
              onChange={handleShowPayment}
              orderStatus={orderStatus}
            />
          )}
          {paymentMethod && paymentMethod.id && (
            <>
              <Payment
                paymentMethod={paymentMethod}
                customerId={customer?.id}
                title='Payment Method'
                orderStatus={orderStatus}
              />{' '}
              {billingAddress && (
                <>
                  <Address
                    address={billingAddress}
                    title='Billing Address'
                    customerId={customer?.id}
                    orderStatus={orderStatus}
                    paymentMethodId={paymentMethod.id}
                  />
                </>
              )}
            </>
          )}
          {showDialog && (
            <CustomerPaymentDialog
              onClose={handleClosePayment}
              customerId={customer?.id}
              selectedPayment={paymentMethod?.id}
            />
          )}

          {/* {!billingAddress && !id && (
            <AddAddress
              title='Billing Address'
              value='Billing Address'
              onChange={handleCreateAddress}
            />
          )} */}
        </div>
      </div>
      {address.dialog && (
        <CustomerAddressDialog
          onClose={handleCloseAddress}
          customerId={customer.id}
          title={address.title}
        />
      )}
    </Card>
  )
}

export default Customer

export const AddAddress = ({title, value, onChange, orderStatus}: any) => {
  if (orderStatus === draftOrderTypes.open) {
    return (
      <div className='d-flex flex-column'>
        <div className='d-flex align-items-center fs-5 fw-bolder mb-5 justify-content-between'>
          {title}
          <button
            id='btnCusAddCreate'
            className='btn btn-sm btn-link'
            data-bs-toggle='modal'
            value={value}
            data-bs-target='#kt_modal_new_address'
            onClick={onChange}
          >
            Create
          </button>
        </div>
      </div>
    )
  }
  return null
}
